import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { isValid } from '../../../../utils';
import './sub-head.scss';

const SubHead = ({ data, className, articleLayout, type, slug, isPage, editorsExpertsClass }) => {
  if (!isValid(data)) {
    return null;
  }

  const myRef = useRef({});
  const myElement = myRef.current;
  const hasId = isValid(myElement.id);
  // Future refactor: Make h2Id so that it isolates only the text if part of a linked H2 (like in a large-product module, social embed etc)
  let h2Id = data.replace(/\s+/g, '-').toLowerCase();
  h2Id = !hasId && data === 'Why Trust PureWow' ? 'disclaimer' : h2Id;
  const newId = hasId ? myElement.id : h2Id;

  const subheadClass = (isValid(type) && type === 'sub-head') ? 'sub-head miniheader' : className;
  const revisedClass = (isValid(articleLayout) && articleLayout === 'Standard') ? `${subheadClass} standard` : subheadClass;
  const reRevisedClass = (isValid(articleLayout) && articleLayout === 'Content Hub') ? `${subheadClass} content-hub` : revisedClass;
  const reReRevisedClass = (isPage && isValid(editorsExpertsClass) && (slug === 'experts' || slug.includes('purewow-team') || slug === 'about-us') && slug !== 'commerce-policy') ? `${className} experts` : reRevisedClass;
  const reReReRevisedClass = (isPage && !isValid(editorsExpertsClass) && (slug === 'experts' || slug.includes('purewow-team') || slug === 'about-us') && slug !== 'commerce-policy') ? `${className} page-reg-h2` : reReRevisedClass;

  try {
    let encodedData = data.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    const htags = ['<h1>', '<h2>', '<h3>', '<h4>', '<h5>', '<h6>'];
    if (encodedData == '<h2></h2>' || encodedData === '') {
      return null;
    } else if (htags.includes(encodedData.slice(0, 4))) {
      encodedData = encodedData.slice(4,-5);
    }
    return (
      <>
      {!isPage &&
        <h2 className={reReReRevisedClass} ref={myRef} id={newId} dangerouslySetInnerHTML={ { __html: encodedData } } />
      }
      {isPage &&
        <h2 className={reReReRevisedClass} ref={myRef} id={newId} dangerouslySetInnerHTML={ { __html: encodedData } } />
      }
      </>
      
      );
  } catch (e) {
    console.log(e);
    return null;
  }
};

SubHead.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};

export default SubHead;
